type Guid = any;

export class v_InventoryBus 
{
    inventoryId: Guid;
    isActive: boolean;
    number: string;
    model: string;
    inventoryName: string;
    inventoryDesc: string;
    notes: string;
    dateadded: Date;
    inventoryTypeName: string;
    inventoryCategoryName: string;
    manufacturerName: string;
    manufacturerTypeName: string;
    inventorySubCategoryName: string;
    currentCost: number;
    lastCost: number;
    flatCost: number;
    ratio: number;
    cpRatio: number;
    internationalCost: number;
    manufacturerNumber: string;
    isPart: boolean;
    rate: number;
    billingTypeId: Guid;
    avgCost: number;
    incomeAccountId: Guid;
    costAccountId: Guid;
    inventoryAccountId: Guid;
    costMultiplier: number;
    supplierPartNumbers: string;
    minThreshold:number;
    maxThreshold:number;
    isCommon: boolean;
    equipmentId: Guid;
    fullDescription: string;
    nonPart: boolean;
    inventoryTypeId: Guid;
    inventoryCategoryId: Guid;
    inventorySubCategoryId: Guid;
    manufacturerId: Guid;
    manufacturerTypeId: Guid;
    companyId: Guid;
    vendorNbr: string;
    maxCost: number;
    zuggitMaxCost: number;
    isTool: boolean;
    isRefrigerant: boolean;
    isNonInvPart: boolean;
    wgtAvgCost: number;
    costVerifyThreshold: number;
}
